import { ReportElement } from './report-element';
import { ReportUnits } from './report-units';
import { ReportPaperSize } from './report-paper-size';
import { ReportPageMargin } from './report-page-margin';
import { ReportCommonSection } from './report-common-section';
import { TemplateDataPlate, TemplateText, TemplateDataPlateImageInfo, TemplateDataPlateText, TemplateImage, Validation, Options } from './report-template';
import { ElementType } from './element-type';
import { ReportPreviewMetadata, PropertyPreviewMetadata, UpdateMetadata, FieldType } from '../_services/report-template-design.service';
import { Subscription } from 'rxjs';
import { FONT_FAMILY, BORDER_STYLE, DYNAMIC_SELECT_ITEM_DATAPLATE_VISOL, FONT_STYLE, FONT_WEIGHT, INPUT_TYPES} from '../app.constants';
import { ReportFonts } from './report-fonts';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';

export class ReportDataPlate extends ReportElement {

  public top: string;
  public left: string;
  public width: string;
  public height: string;
  public zIndex: number;

  //public title: TemplateText;
  public titleTop: string;
  public titleLeft: string;
  public titleWidth: string;
  public titleHeight: string;
  public titlePadding: string;
  public titlePaddingLeft: string;
  public titlePaddingBottom: string;
  public titlePaddingRight: string;
  public titlePaddingTop: string;
  public titleZIndex: number;
  public titleText: string;
  public titleFontSize: string;
  public titleFontFamily: string;
  public titleFontColor: string;
  public titleFontStyle: string;
  public titleFontWeight: string;
  public titleLineHeight: string;
  public titleTextAlign: string;
  public titleVerticalAlign: string;
  public titleBorderWidth: string;
  public titleBorderStyle: string;
  public titleBorderColor: string;
  public titleBackgroundColor: string;
  public titleIsHorizontal: boolean;
  public titleJustifyContent: string;
  public titleAlignItems: string;

  public titleType: string;
  public titleFormat: string;
  public titleDynamicId: string;
  public titleInputType: string;
  public titleEditableId: string;
  public titleValidation: Validation;
  public titleRadioType: string;
  public titleRadioLabel: string;
  public titleOptions: Options[];
  public titleMultiSelectDelimiter: string;
  public titleLabel: string;
  public titleValue: string;
  public titleInputGroup: string;

  public imageInfo: TemplateDataPlateImageInfo;
  public imageInfoTop: string;
  public imageInfoLeft: string;
  public imageInfoWidth: string;
  public imageInfoHeight: string;
  public imageInfoZIndex: number;
  public imageInfoTitle: TemplateDataPlateText;
  public imageInfoTitleTop: string;
  public imageInfoTitleLeft: string;
  public imageInfoTitleWidth: string;
  public imageInfoTitleHeight: string;
  public imageInfoTitleZIndex: number;
  public imageInfoTitleText: string;

  public imageInfoTitleFontSize: string;
  public imageInfoTitleFontFamily: string;
  public imageInfoTitleFontColor: string;
  public imageInfoTitleFontStyle: string;
  public imageInfoTitleFontWeight: string;
  public imageInfoTitleLineHeight: string;
  public imageInfoTitleTextAlign: string;
  public imageInfoTitleVerticalAlign: string;
  public imageInfoTitleBorderWidth: string;
  public imageInfoTitleBorderStyle: string;
  public imageInfoTitleBorderColor: string;
  public imageInfoTitleBackgroundColor: string;
  public imageInfoTitleIsHorizontal: boolean;

  public imageInfoImage: TemplateImage;
  public imageInfoImageTop: string;
  public imageInfoImageLeft: string;
  public imageInfoImageWidth: string;
  public imageInfoImageHeight: string;
  public imageInfoImageZIndex: number;
  public imageInfoImageCaption: string;
  public imageInfoImageSrc: string;
  public imageInfoImageType: string;
  public imageInfoImageOrientation: number;

  public tableResize: boolean;
  public tableTopValue: number;
  public tableLeftValue: number;

  private units: ReportUnits;
  private fonts: ReportFonts;
  private paperSize: ReportPaperSize;
  private pageMargin: ReportPageMargin;
  private header: ReportCommonSection;
  private footer: ReportCommonSection;

  private baseDef: TemplateDataPlate;
  private readonly metaId = 'id';
  private readonly metaTop = 'y';
  private readonly metaLeft = 'x';
  private readonly metaWidth = 'width';
  private readonly metaHeight = 'height';
  private readonly metaZIndex = 'zIndex';
  private readonly metaTitle = 'title';
  private readonly metaBorderWidth = 'borderWidth';
  private readonly metaBorderStyle = 'borderStyle';
  private readonly metaBorderColor = 'borderColor';
  private readonly metaBGColor = 'backgroundColor';
  private readonly metaFontSize = 'fontSize';
  private readonly metaFontFamily = 'fontFamily';
  private readonly metaFontStyle = 'fontStyle';
  private readonly metaFontWeight = 'fontWeight';
  private readonly metaFontColor = 'fontColor';
  private readonly metaTextAlign = 'horizontalAlign';
  private readonly metaVerticalAlign = 'verticalAlign';
  private readonly metaLineHeight = 'lineHeight';
  private readonly metaPaddingLeft = 'paddingLeft';
  private readonly metaPaddingBottom = 'paddingBottom';
  private readonly metaPaddingRight = 'paddingRight';
  private readonly metaPaddingTop = 'paddingTop';
  private readonly metaText = 'text';

  private readonly metaIsHorizontal = 'isHorizontal';
  private readonly metaType = 'type';
  private readonly metaDynamicId = 'dynamicId';
  private readonly metaEditableId = 'editableId';
  private readonly metaInputType = 'inputType';
  private readonly metaValidation = 'validation';
  private readonly metaFormat = 'format';
  private readonly metaRequired = 'validation.required';
  private readonly metaMaxLength = 'validation.maxLength';
  private readonly metaRadioType = 'radioType';
  private readonly metaRadioLabel = 'radioLabel';
  private readonly metaOptions = 'options';
  private readonly metaMultiSelectDelimiter = 'multiSelectDelimiter';
  private readonly metaLabel = 'label';
  private readonly metaValue = 'value';
  private readonly metaInputGroup = 'inputGroup';

  private readonly metaImageInfo = 'imageInfo';
  private readonly metaImageInfoTitle = 'imageInfoTitle';
  private readonly metaImageInfoTable = 'imageInfoTable'
  private readonly metaImage = 'image';
  private readonly metaCaption = 'caption';
  private readonly metaSrc = 'src';
  private readonly metaOrientaion = 'orientation';

  constructor(
    type: ElementType,
    index: number,
    units: ReportUnits,
    fonts: ReportFonts, 
    header: ReportCommonSection,
    footer: ReportCommonSection,
    paperSize: ReportPaperSize,
    pageMargin: ReportPageMargin,
    protected translate: TranslateService,
    protected langService: LangUpdateService,
    templateDataPlate?: TemplateDataPlate
  ) {
    super(type, index, !(templateDataPlate == null), translate, langService, templateDataPlate ? templateDataPlate.id : null);

    this.units = units;
    this.fonts = fonts;
    this.header = header;
    this.footer = footer;
    this.paperSize = paperSize;
    this.pageMargin = pageMargin;
    
    if (templateDataPlate) {
      this.baseDef = templateDataPlate;

    } else {
      const title = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum())), // 初期値を0で仮設定
        height: Math.floor(this.pageMargin.getPaddedHeightNum(this.paperSize.getHeightNum())), // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        borderColor: null,
        borderStyle: null,
        borderWidth: null,
        backgroundColor: null,
        type: 'static', // 初期値をstaticで仮設定
        text: null,
        format: null,
        fontSize: this.fonts.getInitailFontSize(),
        fontFamily: this.fonts.getInitialFontFamily(),
        fontColor: null,
        fontStyle: null,
        fontWeight: null,
        horizontalAlign: 'left', // 初期値をleftで仮設定
        verticalAlign: 'middle', // 初期値をcenterで仮設定
        isHorizontal: true, // 初期値をtrueで設定
        lineHeight: null,
        dynamicId: null,
        dynamicDataField: null, // 初期値をnullで仮設定
        inputType: 'text', // 初期値をtextで仮設定
        editableId: null,
        validation: {
          required: false,
          maxLength: 100,
        },
        radioType: null,
        radioLabel: null,
        options: [],
        label: null,
        value: null,
        inputGroup: null,
        padding: null,
        paddingRight: 0.5,
        paddingBottom: 0.5,
        paddingLeft: 0.5,
        paddingTop: 0.5,
        multiSelectDelimiter: 'comma'
      };
      const imageInfoTitle = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum())), // 初期値を0で仮設定
        height: 0, // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        borderColor: null,
        borderStyle: null,
        borderWidth: null,
        backgroundColor: null,
        text: null,
        format: null,
        fontSize: this.fonts.getInitailFontSize(),
        fontFamily: this.fonts.getInitialFontFamily(),
        fontColor: null,
        fontStyle: null,
        fontWeight: null,
        horizontalAlign: 'left', // 初期値をleftで仮設定
        verticalAlign: 'middle', // 初期値をcenterで仮設定
        isHorizontal: true, // 初期値をtrueで設定
        lineHeight: null,
        padding: null,
        paddingRight: 0.5,
        paddingBottom: 0.5,
        paddingLeft: 0.5,
        paddingTop: 0.5,
        position: 'top', // 初期値をtopで仮設定
      };
      const imageInfoImage = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum())/2), // 初期値を0で仮設定
        height: 0, // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        src: null,
        type: 'static', // 初期値をstaticで仮設定
        dynamicDataField: null, // 初期値をnullで仮設定
        dynamicId: null
      };
      this.baseDef = {
        id: this.generateUUID(),
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        zIndex: 0,
        title: title,
        imageInfo: {
          id: this.generateUUID(),
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          zIndex: 0,
          title: imageInfoTitle,
          image: imageInfoImage
        }
      };
    }
    // title
    this.titleTop = this.units.concatenate('sizeUnit', this.baseDef.title.y);
    this.titleLeft = this.units.concatenate('sizeUnit', this.baseDef.title.x);
    this.titleWidth = this.units.concatenate('sizeUnit', this.baseDef.title.width);
    this.titleHeight = this.units.concatenate('sizeUnit', this.baseDef.title.height);
    this.titleZIndex = this.baseDef.title.zIndex;
    this.titleFontColor = this.baseDef.title.fontColor;
    this.titleFontFamily = this.baseDef.title.fontFamily;
    this.titleFontSize = this.units.concatenate('fontSizeUnit', this.baseDef.title.fontSize);
    this.titleFontStyle = this.baseDef.title.fontStyle;
    this.titleFontWeight = this.baseDef.title.fontWeight;
    this.titleVerticalAlign = this.baseDef.title.verticalAlign;
    this.titleTextAlign = this.baseDef.title.horizontalAlign;
    this.titleLineHeight = this.units.concatenate('sizeUnit', this.baseDef.title.lineHeight);
    this.titleBackgroundColor = this.baseDef.title.backgroundColor;
    this.titleBorderColor = this.baseDef.title.borderColor;
    this.titleBorderStyle = this.baseDef.title.borderStyle;
    this.titleBorderWidth = this.units.concatenate('sizeUnit', this.baseDef.title.borderWidth);
    this.titleText = this.getText(this.baseDef.title);
    this.titleJustifyContent = this.getJustifyContent();
    this.titleAlignItems = this.getAlignItems();
    this.titleType = this.baseDef.title.type;
    this.titleFormat = this.baseDef.title.format;
    this.titleDynamicId = this.baseDef.title.dynamicId;
    this.titleInputType = this.baseDef.title.inputType;
    this.titleEditableId = this.baseDef.title.editableId;
    this.titleValidation = this.baseDef.title.validation;
    this.titleRadioType = this.baseDef.title.radioType;
    this.titleRadioLabel = this.baseDef.title.radioLabel;
    this.titleOptions = this.baseDef.title.options;
    this.titleMultiSelectDelimiter = this.baseDef.title.multiSelectDelimiter;
    this.titleLabel = this.baseDef.title.label;
    this.titleValue = this.baseDef.title.value;
    this.titleInputGroup = this.baseDef.title.inputGroup;
    // imageInfo
    this.imageInfoTop = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.y);
    this.imageInfoLeft = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.x);
    this.imageInfoWidth = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.width);
    this.imageInfoHeight = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.height);
    this.imageInfoZIndex = this.baseDef.imageInfo.zIndex;
    // imageInfo - title
    this.imageInfoTitle = this.baseDef.imageInfo.title;
    if (this.imageInfoTitle !== null) {
      this.imageInfoTitleTop = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.y);
      this.imageInfoTitleLeft = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.x);
      this.imageInfoTitleWidth = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.width);
      this.imageInfoTitleHeight = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.height);
      this.imageInfoTitleZIndex = this.baseDef.imageInfo.title.zIndex;
      this.imageInfoTitleFontSize = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.fontSize as number);
      this.imageInfoTitleFontFamily = this.baseDef.imageInfo.title.fontFamily;
      this.imageInfoTitleFontColor = this.baseDef.imageInfo.title.fontColor;
      this.imageInfoTitleFontStyle = this.baseDef.imageInfo.title.fontStyle;
      this.imageInfoTitleFontWeight = this.baseDef.imageInfo.title.fontWeight;
      if (this.baseDef.imageInfo.title.lineHeight as number === 0) {
        this.imageInfoTitleLineHeight = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.lineHeight as number);
      } else {
        this.imageInfoTitleLineHeight = 'initial'
      }
      this.imageInfoTitleTextAlign = this.baseDef.imageInfo.title.horizontalAlign;
      this.imageInfoTitleVerticalAlign = this.baseDef.imageInfo.title.verticalAlign;
      this.imageInfoTitleBorderWidth = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.title.borderWidth as number);
      this.imageInfoTitleBorderStyle = this.baseDef.imageInfo.title.borderStyle;
      this.imageInfoTitleBorderColor = this.baseDef.imageInfo.title.borderColor;
      this.imageInfoTitleBackgroundColor = this.baseDef.imageInfo.title.backgroundColor;
      this.imageInfoTitleIsHorizontal = this.baseDef.imageInfo.title.isHorizontal;
    }
    // imageInfo - image
    this.imageInfoImage = this.baseDef.imageInfo.image;
    if (this.imageInfoImage !== null) {
      this.imageInfoImageTop = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.image.y);
      this.imageInfoImageLeft = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.image.x);
      this.imageInfoImageWidth = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.image.width);
      this.imageInfoImageHeight = this.units.concatenate('sizeUnit', this.baseDef.imageInfo.image.height);
      this.imageInfoImageZIndex = this.baseDef.imageInfo.image.zIndex;
    }

    this.tableResize = false;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public setDrawData(metadata: ReportPreviewMetadata) {
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.topPx),
      oldValue: this.baseDef[this.metaTitle][this.metaTop]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.leftPx),
      oldValue: this.baseDef[this.metaTitle][this.metaLeft]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaWidth,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.widthPx),
      oldValue: this.baseDef[this.metaTitle][this.metaWidth]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaHeight,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.heightPx / 5),
      oldValue: this.baseDef[this.metaTitle][this.metaHeight]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.topPx + metadata.heightPx / 5),
      oldValue: this.baseDef[this.metaImageInfo][this.metaTop]
    })

    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.leftPx),
      oldValue: this.baseDef[this.metaImageInfo][this.metaLeft]
    })

    this.updateProperties({
      id: this.getId(),
      name: this.metaWidth,
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.widthPx),
      oldValue: this.baseDef[this.metaImageInfo][this.metaWidth]
    })

    this.updateProperties({
      id: this.getId(),
      name: this.metaHeight,
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.heightPx - metadata.heightPx / 5),
      oldValue: this.baseDef[this.metaImageInfo][this.metaHeight]
    })

    // this.updateProperties({
    //   id: this.getId(),
    //   name: 'title.y',
    //   parentName: this.metaImageInfo,
    //   value: this.units.fromPx('sizeUnit', metadata.heightPx / 5),
    //   oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaTop]
    // })

    // this.updateProperties({
    //   id: this.getId(),
    //   name: this.metaLeft,
    //   parentName: this.metaImageInfo,
    //   value: this.units.fromPx('sizeUnit', metadata.leftPx),
    //   oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaLeft]
    // })

    this.updateProperties({
      id: this.getId(),
      name: 'title.width',
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.widthPx),
      oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaWidth]
    })

    this.updateProperties({
      id: this.getId(),
      name: 'title.height',
      parentName: this.metaImageInfo,
      //value→imageInfo.height * 1/2 * 1/5
      value: this.units.fromPx('sizeUnit', metadata.heightPx * 2 / 25),
      oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaHeight]
    })

    this.updateProperties({
      id: this.getId(),
      name: 'image.y',
      parentName: this.metaImageInfo,
      //value→imageInfo.title.y
      value: this.units.fromPx('sizeUnit', metadata.heightPx * 2 / 25),
      oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaTop]
    })

    // this.updateProperties({
    //   id: this.getId(),
    //   name: this.metaLeft,
    //   parentName: this.metaImageInfo,
    //   value: this.units.fromPx('sizeUnit', metadata.leftPx),
    //   oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaLeft]
    // })

    this.updateProperties({
      id: this.getId(),
      name: 'image.width',
      parentName: this.metaImageInfo,
      value: this.units.fromPx('sizeUnit', metadata.widthPx / 2),
      oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaWidth]
    })

    this.updateProperties({
      id: this.getId(),
      name: 'image.height',
      parentName: this.metaImageInfo,
      //value→imageInfo.height * 1/2 * 4/5
      value: this.units.fromPx('sizeUnit', metadata.heightPx * 8 / 25),
      oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaHeight]
    })
  }
  public setDropData(metadata: ReportPreviewMetadata) {
    this.tableTopValue = Math.round((this.units.fromPx('sizeUnit', metadata.topPx) + this.baseDef[this.metaImageInfo][this.metaTop] - this.baseDef[this.metaTitle][this.metaTop]) * 10) / 10;
    this.tableLeftValue = Math.round((this.units.fromPx('sizeUnit', metadata.leftPx) + this.baseDef[this.metaImageInfo][this.metaLeft] - this.baseDef[this.metaTitle][this.metaLeft]) * 10) / 10;
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.topPx),
      oldValue: this.baseDef[this.metaTitle][this.metaTop]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaTitle,
      value: this.units.fromPx('sizeUnit', metadata.leftPx),
      oldValue: this.baseDef[this.metaTitle][this.metaLeft]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaImageInfo,
      value: this.tableTopValue,
      oldValue: this.baseDef[this.metaImageInfo][this.metaTop]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaImageInfo,
      value: this.tableLeftValue,
      oldValue: this.baseDef[this.metaImageInfo][this.metaLeft]
    });
  }

  public setResizeData(metadata: ReportPreviewMetadata) {
    if (this.tableResize) {
      this.updateProperties({
        id: this.getId(),
        name: this.metaTop,
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.topPx),
        oldValue: this.baseDef[this.metaImageInfo][this.metaTop]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaLeft,
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.leftPx),
        oldValue: this.baseDef[this.metaImageInfo][this.metaLeft]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaWidth,
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.widthPx),
        oldValue: this.baseDef[this.metaImageInfo][this.metaWidth]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaHeight,
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.heightPx),
        oldValue: this.baseDef[this.metaImageInfo][this.metaHeight]
      });
      this.updateProperties({
        id: this.getId(),
        name: 'image.width',
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.widthPx / 2),
        oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaWidth]
      });
      this.updateProperties({
        id: this.getId(),
        name: 'image.height',
        parentName: this.metaImageInfo,
        //value→imageInfo.height * 1/2 * 4/5
        value: this.units.fromPx('sizeUnit', metadata.heightPx * 21 / 50),
        oldValue: this.baseDef[this.metaImageInfo][this.metaImage][this.metaHeight]
      });
      this.updateProperties({
        id: this.getId(),
        name: 'title.width',
        parentName: this.metaImageInfo,
        value: this.units.fromPx('sizeUnit', metadata.widthPx),
        oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaWidth]
      });
      this.updateProperties({
        id: this.getId(),
        name: 'title.height',
        parentName: this.metaImageInfo,
        //value→imageInfo.height * 1/2 * 1/5
        value: this.units.fromPx('sizeUnit', metadata.heightPx * 2 / 25),
        oldValue: this.baseDef[this.metaImageInfo][this.metaTitle][this.metaHeight]
      });
    }
    else {
      this.updateProperties({
        id: this.getId(),
        name: this.metaTop,
        parentName: this.metaTitle,
        value: this.units.fromPx('sizeUnit', metadata.topPx),
        oldValue: this.baseDef[this.metaTitle][this.metaTop]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaLeft,
        parentName: this.metaTitle,
        value: this.units.fromPx('sizeUnit', metadata.leftPx),
        oldValue: this.baseDef[this.metaTitle][this.metaLeft]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaWidth,
        parentName: this.metaTitle,
        value: this.units.fromPx('sizeUnit', metadata.widthPx),
        oldValue: this.baseDef[this.metaTitle][this.metaWidth]
      });
      this.updateProperties({
        id: this.getId(),
        name: this.metaHeight,
        parentName: this.metaTitle,
        value: this.units.fromPx('sizeUnit', metadata.heightPx),
        oldValue: this.baseDef[this.metaTitle][this.metaHeight]
      });
    }
  }

  public getBaseDef(): TemplateDataPlate{
    return this.baseDef;
  }
  public getSizeUnit(){
    return this.baseDef['sizeUnit'];
  }
  public getLeftPx(): number {
    if (this.tableResize) {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaLeft]);
    }
    else {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaLeft]);
    }
  }
  public getTopPx(): number {
    if (this.tableResize) {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaTop]);
    }
    else {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaTop]);
    }
  }
  public getWidthPx(): number {
    if (this.tableResize) {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaWidth]);
    }
    else {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaWidth]);
    }
  }
  public getHeightPx(): number {
    if (this.tableResize) {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaHeight]);
    }
    else {
      return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaHeight]);
    }
  }

  public getTitleWidthPx(): number {
    return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaWidth]);
  }
  public getTitleHeightPx(): number {
    return this.units.toPx('sizeUnit', this.baseDef[this.metaTitle][this.metaHeight]);
  }
  public getImageWidthPx(): number {
    return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaWidth]);
  }
  public getImageHeightPx(): number {
    return this.units.toPx('sizeUnit', this.baseDef[this.metaImageInfo][this.metaHeight]);
  }

  public getTitleTopNum(): number {
    return this.baseDef.title.y;
  }

  public getTemplateJSON(): TemplateDataPlate {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaLeft, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'TITLE',
      },
      {
        name: this.metaTop, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'TITLE',
      },
      {
        name: this.metaZIndex, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Integer',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'TITLE'
      },
      {
        name: this.metaHeight, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Size',
        category: 'TITLE'
      },
      {
        name: this.metaWidth, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Size',
        category: 'TITLE'
      },
      {
        name: this.metaPaddingLeft, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaPaddingBottom, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaPaddingRight, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaPaddingTop, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaVerticalAlign, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'top', value: 'top' },
          { label: 'middle', value: 'middle' },
          { label: 'bottom', value: 'bottom' },
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaTextAlign, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'left', value: 'left' },
          { label: 'center', value: 'center' },
          { label: 'right', value: 'right' },
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaLineHeight, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        // ↑ CSSプロパティ「lineHight」は文字列値も受け付けられたような。。。
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TextBox',
        category: 'TITLE'
      },
      {
        name: this.metaBorderStyle, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: BORDER_STYLE,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Line',
        category: 'TITLE'
      },
      {
        name: this.metaBorderWidth, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Line',
        category: 'TITLE'
      },
      {
        name: this.metaBorderColor, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Line',
        category: 'TITLE'
      },
      {
        name: this.metaBGColor, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Background',
        category: 'TITLE'
      },
      {
        name: this.metaFontSize, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Font',
        category: 'TITLE'
      },
      {
        name: this.metaFontFamily, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_FAMILY,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Font',
        category: 'TITLE'
      },
      {
        name: this.metaFontColor, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Font',
        category: 'TITLE'
      },
      {
        name: this.metaFontStyle, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_STYLE,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Font',
        category: 'TITLE'
      },
      {
        name: this.metaFontWeight, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_WEIGHT,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Font',
        category: 'TITLE'
      },
      {
        name: this.metaType, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'static', value: 'static' },
          { label: 'dynamic', value: 'dynamic' },
          { label: 'dynamic-editable', value: 'dynamic-editable' },
        ],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaInputType, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: INPUT_TYPES,
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaText, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'TextArea',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaDynamicId, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: DYNAMIC_SELECT_ITEM_DATAPLATE_VISOL,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaFormat, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: '01/01/2019', value: 'MM/dd/yyyy' },
          { label: '1/1/2019', value: 'M/d/yyyy' },
          { label: '1/1/19', value: 'M/d/yy' },
          { label: '2019/1/1', value: 'yyyy/M/d' },
          { label: '19/1/1', value: 'yy/M/d' },
          { label: '2019-01-01', value: 'yyyy-MM-dd' },
          { label: '2019-1-1', value: 'yyyy-M-d' },
          { label: '19-01-01', value: 'yy-MM-dd' },
          { label: 'January 1, 2019', value: 'MMMM d, yyyy' },
          { label: 'January 01, 2019', value: 'MMMM dd, yyyy' },
          { label: 'Tuesday, January 01, 2019', value: 'dddd, MMMM dd, yyyy' },
          { label: 'Tuesday, Jan 1, 2019', value: 'dddd, MMM d, yyy' },
          { label: 'Tues, Jan 1, 2019', value: 'ddd, MMM d, yyyy' },
          { label: '1/10', value: '$/#' },
          { label: '1', value: '$' },
          { label: 'p.1', value: 'p.$' },
          { label: 'Page 1 of 10', value: 'Page $ of #' },
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaMaxLength, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Integer',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaRequired, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'CheckBox',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'DataBinding',
        category: 'TITLE'
      },
      {
        name: this.metaOptions, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Multi',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Select',
        category: 'TITLE'
      },
      {
        name: this.metaMultiSelectDelimiter, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          {label: 'comma', value: 'comma'},
          {label: 'new line', value: 'newline'}
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Select',
        category: 'TITLE'
      },
      {
        name: this.metaRadioType, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'check', value: 'check' },
          { label: 'circle', value: 'circle' },
          { label: 'disc', value: 'disc' },
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: false,
        group: 'Radio',
        category: 'TITLE'
      },
      {
        name: this.metaRadioLabel, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Text',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: false,
        group: 'Radio',
        category: 'TITLE'
      },
      {
        name: this.metaValue, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Text',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: false,
        group: 'Radio',
        category: 'TITLE'
      },
      {
        name: this.metaEditableId, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Text',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Input',
        category: 'TITLE'
      },
      {
        name: this.metaLabel, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Text',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Input',
        category: 'TITLE'
      },
      {
        name: this.metaInputGroup, parentName: this.metaTitle, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Text',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Input',
        category: 'TITLE'
      },
      {
        name: this.metaLeft, parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'IMAGEINFO'
      },
      {
        name: this.metaTop, parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'IMAGEINFO'
      },
      {
        name: this.metaZIndex, parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Integer',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Position',
        category: 'IMAGEINFO'
      },
      {
        name: this.metaHeight, parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Size',
        category: 'IMAGEINFO'
      },
      {
        name: this.metaWidth, parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Size',
        category: 'IMAGEINFO'
      },
      {
        name: 'image.width', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'Image',
        category: 'IMAGEINFOIMAGE'
      },
      {
        name: 'image.height', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'Image',
        category: 'IMAGEINFOIMAGE'
      },
      {
        name: 'title.x', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitlePosition',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.y', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitlePosition',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.zIndex', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Integer',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitlePosition',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.width', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitleSize',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.height', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleSize',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.paddingLeft', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.paddingBottom', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.paddingRight', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.paddingTop', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.verticalAlign', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'top', value: 'top' },
          { label: 'middle', value: 'middle' },
          { label: 'bottom', value: 'bottom' }
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.horizontalAlign', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'left', value: 'left' },
          { label: 'center', value: 'center' },
          { label: 'right', value: 'right' }
        ],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.lineHeight', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleTextBox',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.borderStyle', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: BORDER_STYLE,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleLine',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.borderWidth', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleLine',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.borderColor', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitleLine',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.backgroundColor', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitleBackground',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.fontSize', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Number',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.fontFamily', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_FAMILY,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.fontColor', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Color',
        selectItems: [],
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.fontStyle', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_STYLE,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.fontWeight', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: FONT_WEIGHT,
        isRequired: false,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      },
      {
        name: 'title.position', parentName: this.metaImageInfo, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'top', value: 'top' },
          { label: 'bottom', value: 'bottom' },
        ],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
        group: 'TitleFont',
        category: 'IMAGEINFOTITLE'
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    const metaDataList = metadata.name.split('.');
    switch (metaDataList[0]) {
      case this.metaTop:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleTop = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoTop = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaLeft:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleLeft = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoLeft = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaWidth:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleWidth = this.units.concatenate('sizeUnit', this.baseDef.title.width);
        }
        else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoWidth = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaHeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleHeight = this.units.concatenate('sizeUnit', this.baseDef.title.height);
        }
        else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoHeight = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaZIndex:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleZIndex = metadata.value as number;
        }
        else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoZIndex = metadata.value as number;
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaBorderColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderColor = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaBorderStyle:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderStyle = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaBorderWidth:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderWidth = this.units.concatenate('sizeUnit', metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaTextAlign:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleTextAlign = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;

      case this.metaBGColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleBackgroundColor = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        if (metadata.value === 'static') {
          this.setPreviewValue(this.metaDynamicId, null, metadata.parentName);
          this.baseDef[this.metaDynamicId] = null;
          this.setPreviewValue(this.metaEditableId, null, metadata.parentName);
          this.baseDef[this.metaEditableId] = null;
          this.setPreviewValue(this.metaFormat, null, metadata.parentName);
          this.baseDef[this.metaFormat] = null;
        } else if (metadata.value === 'dynamic') {
          this.setPreviewValue(this.metaText, '', metadata.parentName);
          this.baseDef[this.metaText] = '';
          this.setPreviewValue(this.metaEditableId, null, metadata.parentName);
          this.baseDef[this.metaEditableId] = null;
        }
        break;
      case this.metaText:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaFormat:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaFontSize:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleFontSize = this.fonts.getFontSize(this.baseDef.title);
          this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        }
        break;
      case this.metaFontFamily:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleFontFamily = this.fonts.getFontFamily(this.baseDef.title);
          this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        }
        break;
      case this.metaFontColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontColor = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaFontStyle:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontStyle = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaFontWeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontWeight = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaVerticalAlign:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleVerticalAlign = metadata.value as string;
        this.titleAlignItems = this.getAlignItems();
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaIsHorizontal:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as boolean;
        this.titleIsHorizontal = metadata.value as boolean;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaLineHeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titleLineHeight = this.units.concatenate('sizeUnit', metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaDynamicId:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaInputType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        if (metadata.value !== 'select' && metadata.value !== 'multiSelect') {
          this.setPreviewValue(this.metaOptions, '[]');
          this.baseDef[metadata.parentName][this.metaOptions] = [];
        }
        if (metadata.value !== 'select' && metadata.value !== 'multiSelect') {
          this.setPreviewValue(this.metaMultiSelectDelimiter, 'comma');
          this.baseDef[this.metaMultiSelectDelimiter] = 'comma';
        }
        if (metadata.value !== 'radio') {
          this.setPreviewValue(this.metaRadioType, null, metadata.parentName);
          this.baseDef[metadata.parentName][this.metaRadioType] = null;
          this.setPreviewValue(this.metaRadioLabel, null, metadata.parentName);
          this.baseDef[metadata.parentName][this.metaRadioLabel] = null;
          this.setPreviewValue(this.metaValue, null, metadata.parentName);
          this.baseDef[metadata.parentName][this.metaValue] = null;
        }
        break;
      case this.metaEditableId:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaValidation:
        if (!this.baseDef[metadata.parentName][metaDataList[0]]) {
          this.baseDef[metadata.parentName][metaDataList[0]] = { required: false, maxLength: null };
        }
        this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]] = metadata.value as boolean;
        this.setPreviewValue(metaDataList, metadata.value, metadata.parentName);
        break;
      case this.metaRadioType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaRadioLabel:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaOptions:
        this.baseDef[metadata.parentName][metadata.name] = JSON.parse(metadata.value as string);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaMultiSelectDelimiter:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaLabel:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaValue:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaInputGroup:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaPaddingLeft:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titlePaddingLeft = this.units.concatenate('sizeUnit', metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaPaddingBottom:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titlePaddingBottom = this.units.concatenate('sizeUnit', metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaPaddingRight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titlePaddingRight = this.units.concatenate('sizeUnit', metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaPaddingTop:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titlePaddingTop = this.units.concatenate('sizeUnit', metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value, metadata.parentName);
        break;
      case this.metaTitle:
        if (metadata.parentName === this.metaImageInfo) {
          if(metaDataList.length === 2 && metaDataList[1] !== 'options' && metaDataList[1] !== 'inputType'){
            this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]] = metadata.value;
          }
          else if (metaDataList.length === 2 && metaDataList[1] === 'options'){
            this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]] = JSON.parse(metadata.value as string);
          }
          else if (metaDataList.length === 2 && metaDataList[1] === 'inputType'){
            this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]] = metadata.value as string;
            this.setPreviewValue(metaDataList, metadata.value, metadata.parentName);
            if (metadata.value !== 'select' && metadata.value !== 'multiSelect') {
              this.setPreviewValue(this.metaOptions, '[]');
              this.baseDef[metadata.parentName][metaDataList[0]][this.metaOptions] = [];
            }
            if (metadata.value !== 'multiSelect') {
              this.setPreviewValue(['title',this.metaMultiSelectDelimiter], 'comma', metadata.parentName);
              this.baseDef[metadata.parentName][metaDataList[0]][this.metaMultiSelectDelimiter] = 'comma';
            }
            if (metadata.value !== 'radio') {
              this.setPreviewValue(['title',this.metaRadioType], null, metadata.parentName);
              this.baseDef[metadata.parentName][metaDataList[0]][this.metaRadioType] = null;
              this.setPreviewValue(['title',this.metaRadioLabel], null, metadata.parentName);
              this.baseDef[metadata.parentName][metaDataList[0]][this.metaRadioLabel] = null;
              this.setPreviewValue(['title',this.metaValue], null, metadata.parentName);
              this.baseDef[metadata.parentName][metaDataList[0]][this.metaValue] = null;
            }
          }
          else{
            this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]][metaDataList[2]] = metadata.value;
          }
          this.imageInfoTitleTop = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaTop] as number);
          this.imageInfoTitleLeft = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaLeft] as number);
          this.imageInfoTitleWidth = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaWidth] as number);
          this.imageInfoTitleHeight = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaHeight] as number);
          this.imageInfoTitleZIndex = this.baseDef[metadata.parentName][metaDataList[0]][this.metaZIndex] as number;
          this.imageInfoTitleFontSize = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaFontSize] as number);
          this.imageInfoTitleFontFamily = this.baseDef[metadata.parentName][metaDataList[0]][this.metaFontFamily];
          this.imageInfoTitleFontColor = this.baseDef[metadata.parentName][metaDataList[0]][this.metaFontColor];
          this.imageInfoTitleFontStyle = this.baseDef[metadata.parentName][metaDataList[0]][this.metaFontStyle];
          this.imageInfoTitleFontWeight = this.baseDef[metadata.parentName][metaDataList[0]][this.metaFontWeight];
          if (this.baseDef[metadata.parentName][metaDataList[0]][this.metaLineHeight] as number === 0) {
            this.imageInfoTitleLineHeight = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaLineHeight] as number);
          } else {
            this.imageInfoTitleLineHeight = 'initial'
          }
          this.imageInfoTitleTextAlign = this.baseDef[metadata.parentName][metaDataList[0]][this.metaTextAlign];
          this.imageInfoTitleVerticalAlign = this.baseDef[metadata.parentName][metaDataList[0]][this.metaVerticalAlign];
          this.imageInfoTitleBorderWidth = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaBorderWidth] as number);
          this.imageInfoTitleBorderStyle = this.baseDef[metadata.parentName][metaDataList[0]][this.metaBorderStyle];
          this.imageInfoTitleBorderColor = this.baseDef[metadata.parentName][metaDataList[0]][this.metaBorderColor];
          this.imageInfoTitleBackgroundColor = this.baseDef[metadata.parentName][metaDataList[0]][this.metaBGColor];
          this.imageInfoTitleIsHorizontal = this.baseDef[metadata.parentName][metaDataList[0]][this.metaIsHorizontal];

          if(metaDataList.length === 2 && metaDataList[1] !== 'inputType'){
            this.setPreviewValue(metaDataList, metadata.value, metadata.parentName, metaDataList[1]);
          }else{
            this.setPreviewValue(metaDataList, metadata.value, metadata.parentName, metaDataList[2]);
          }
        }
        break;
      case this.metaImage:
        if (metadata.parentName === this.metaImageInfo) {

          this.baseDef[metadata.parentName][metaDataList[0]][metaDataList[1]] = metadata.value;
          this.imageInfoImageTop = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaTop] as number);
          this.imageInfoImageLeft = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaLeft] as number);
          this.imageInfoImageWidth = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaWidth] as number);
          this.imageInfoImageHeight = this.units.concatenate('sizeUnit', this.baseDef[metadata.parentName][metaDataList[0]][this.metaHeight] as number);
          this.imageInfoImageZIndex = this.baseDef[metadata.parentName][metaDataList[0]][this.metaZIndex] as number;

          this.imageInfoImageCaption = this.baseDef[metadata.parentName][metaDataList[0]][this.metaCaption];
          this.imageInfoImageSrc = this.baseDef[metadata.parentName][metaDataList[0]][this.metaSrc];
          this.imageInfoImageType = this.baseDef[metadata.parentName][metaDataList[0]][this.metaType];
          this.imageInfoImageOrientation = this.baseDef[metadata.parentName][metaDataList[0]][this.metaOrientaion];

          this.setPreviewValue(metaDataList, metadata.value, metadata.parentName, metaDataList[1]);
        }
        break;
    }
  }

  protected setChainUpdateFunction(subscribers: Array<Subscription>) {
  }

  private getHeightNum(): number {
    let rtn = this.paperSize.getHeightNum();
    rtn = this.pageMargin.getPaddedHeightNum(rtn);
    rtn = rtn - this.header.getHeightNum() - this.footer.getHeightNum() - (this.baseDef.y * 2);
    rtn = Math.floor(rtn);
    return rtn;
  }

  private getHeight(): string {
    return [this.getHeightNum(), 'mm'].join('');
  }

  private getWidthNum(): number {
    let rtn = this.paperSize.getWidthNum();
    rtn = this.pageMargin.getPaddedWidthNum(rtn) - (this.baseDef.title.x * 2);
    rtn = Math.floor(rtn);
    return rtn;
  }
  private getWidth(): string {
    return [this.getWidthNum(), 'mm'].join('');
  }

  private getText(text: TemplateText): string {
    let rtnText = '';
    switch (text.type) {
      case 'static':
        rtnText = text.text;
        break;
      case 'dynamic':
        if (text.dynamicDataField) {
          rtnText = '[' + this.translate.instant('objects.' + text.dynamicDataField) + ']';
        }
        else if (text.dynamicId) {
          rtnText = '[' + this.translate.instant('objects.' + text.dynamicId) + ']';
        }
        else {
          rtnText = '[' + this.translate.instant('objects.dynamicText') + ']';
        }
        break;
      case 'dynamic-editable':
        rtnText = text.editableId ? '{' + text.editableId + '}' : '{' + this.translate.instant('objects.editableText') + '}';
        break;
    }
    return rtnText;
  }

  private getJustifyContent(): string {
    let rtn: string;
    switch (this.baseDef.title.horizontalAlign) {
      case 'left':
        rtn = 'flex-start';
        break;
      case 'center':
        rtn = 'center';
        break;
      case 'right':
        rtn = 'flex-end';
        break;
    }
    return rtn;
  }

  private getAlignItems(): string {
    let rtn: string;
    switch (this.baseDef.title.verticalAlign) {
      case 'top':
        rtn = 'flex-start';
        break;
      case 'middle':
        rtn = 'center';
        break;
      case 'bottom':
        rtn = 'flex-end';
        break;
    }
    return rtn;
  }

  public getMetadataId() {
    return this.baseDef[this.metaId];
  }
}
